import {
  Answers,
  ConsentQuestion,
  RawQuestionModule,
  ReadOnlyQuestion,
  SingleSelectQuestion,
  TextQuestion,
} from '../questionService'

export enum SignUpQuestionId {
  WHEN_TO_START = 'WHEN_TO_START',
  NEED_MORE_INFO_EARLY_STAGE = 'NEED_MORE_INFO_EARLY_STAGE',
  NEED_MORE_INFO_LATE_STAGE = 'NEED_MORE_INFO_LATE_STAGE',
  FIRST_NAME = 'FIRST_NAME',
  EMAIL = 'EMAIL',
  EMAIL_CONSENT = 'EMAIL_CONSENT',
}

// List of questions that should be static
const whenToStartQuestion = new SingleSelectQuestion(
  SignUpQuestionId.WHEN_TO_START,
  ['FEW_MONTHS', 'SIX_TWELVE_MONTHS', 'NOT_SURE']
)
const needMoreInfoEarlyStageQuestion = new ReadOnlyQuestion(
  SignUpQuestionId.NEED_MORE_INFO_EARLY_STAGE
)
const needMoreInfoLateStageQuestion = new ReadOnlyQuestion(
  SignUpQuestionId.NEED_MORE_INFO_LATE_STAGE
)
const userFirstName = new TextQuestion(SignUpQuestionId.FIRST_NAME)
const userEmail = new TextQuestion(SignUpQuestionId.EMAIL)
const emailConsent = new ConsentQuestion(SignUpQuestionId.EMAIL_CONSENT)

class WhenToStart extends RawQuestionModule {
  evaluate(_answers: Answers) {
    return [whenToStartQuestion]
  }
}

class NeedMoreInfo extends RawQuestionModule {
  evaluate(answers: Answers) {
    if (answers.get(SignUpQuestionId.WHEN_TO_START) === 'FEW_MONTHS') {
      return [needMoreInfoEarlyStageQuestion]
    } else return [needMoreInfoLateStageQuestion]
  }
}

// todo: add email consent here
class UserBasics extends RawQuestionModule {
  evaluate(_answers: Answers) {
    return [userFirstName, userEmail, emailConsent]
  }
}
export const signUpQuestionModules: RawQuestionModule[] = [
  new WhenToStart(),
  new NeedMoreInfo(),
  new UserBasics(),
]
